"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const icons = __importStar(require("../svg"));
const color_1 = require("../../util/color");
// @todo the props spread is problematic here, as you cannot extend AppIcon with custom props without those props being printed on the dom, needs refactor
const AppIcon = (_a) => {
    var { name, iconSize } = _a, props = __rest(_a, ["name", "iconSize"]);
    const theme = (0, react_1.useTheme)();
    const scale = props.size ? theme.iconSizes[props.size] / theme.iconSizes.medium : 1;
    const Icon = icons[name];
    return ((0, jsx_runtime_1.jsx)(Icon, Object.assign({}, props, { style: iconSize ? { width: iconSize, height: iconSize } : { transform: `scale(${scale})` }, slashcolor: props.slashcolor, color: (0, color_1.isFontColor)(props.color) ? theme.text.color[props.color] : props.color })));
};
exports.AppIcon = AppIcon;
//# sourceMappingURL=app_icon.js.map